import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';

@Component({
  selector: 'app-unpaid-addmitted-report',
  templateUrl: './unpaid-addmitted-report.component.html',
  styleUrls: ['./unpaid-addmitted-report.component.scss']
})
export class UnpaidAddmittedReportComponent implements OnInit {

  constructor(private spinner: NgxSpinnerService, public umsService: UmsService,
     public fb: FormBuilder,private modalPopupService: ModalpopService) { }
   courseList: any;
   filteredCourseList: any;
   alladdmittedCountForm: FormGroup
   collegedataList: unknown[];
   filteredListCollege: unknown[];
   allAddmittedCoundatalist: any;
   SessionNo: any;
   table
   count: any;
   dialogRef: MatDialogRef<any>;
  ngOnInit(): void {
    console.log('im in unpaid report');
    
    this.table = false
    this.alladdmittedCountForm = this.fb.group({
      CoCode: new FormControl(''),
      CgCode: new FormControl(''),
    })

    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      // this.spinner.show();
    }

    this.getCourseData();
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      // this.spinner.show();
    }
    );
  }

    getCourseData() {
      this.spinner.show()
      const payload = {};
      this.umsService.fetchCutOffCourse(payload).subscribe(res => {
        if (res.status) {
          this.spinner.hide();
          this.courseList = res.data;
          this.filteredCourseList = this.courseList.slice();
        }
        else {
          this.spinner.hide();
        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      });
    }
  
    getCollegeData(CoCode) {
      this.table =false;
      this.collegedataList = [];
      this.filteredListCollege = []
      this.spinner.show();
      const payload = {};
      payload['CoCode'] = CoCode;
      payload['CgCode'] = '';
      payload['CoStr'] = '';
      this.umsService.getCollegeCourse(payload).subscribe((res) => {
        if (res.status) {
          this.spinner.hide();
          this.collegedataList = Array.from(
            new Map(res.data.map((item) => [item.CgCode, item])).values()
          );
  
          this.filteredListCollege = [...this.collegedataList];
  
        }
        else {
          this.spinner.hide();
          this.collegedataList = [];
          this.filteredListCollege = []
        }
  
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
      })
    }
  
    getRegnCountData() {
  
      const payload = {};
      payload['CoCode'] = this.alladdmittedCountForm.value.CoCode;
      payload['CgCode'] = this.alladdmittedCountForm.value.CgCode;
      payload['RType'] = '0';
      payload['SessionId'] = this.SessionNo;
      this.umsService.getAllAdmitted(payload).subscribe((res) => {
        if (res.status) {
          this.table = true;
          this.allAddmittedCoundatalist = res.data
          this.count = res.data.length
        }
        else {
          this.spinner.hide();
          this.table = false;
          let data = {};
          data['message'] = "No Data Found";
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);  
        }
  
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.table = false;
        let data = {};
        data['message'] = "No Data Found";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);  
      })
    }
  
    download(event: Event) {
      event.preventDefault();
      const payload = {};
      payload['CoCode'] = this.alladdmittedCountForm.value.CoCode;
      payload['CgCode'] = this.alladdmittedCountForm.value.CgCode;
      payload['RType'] = '0';
      payload['SessionId'] = this.SessionNo;
   this.umsService.getAllAdmitted(payload).subscribe((res) => {
        if (res.status) {
          const extractedData = res.data.map(element => ({
            StudentName: element.FullName,
            EmailID: element.StuEmailId,
            MobileNumber: element.StuMobNumber,
            DOB: element.StuBirthDate,
            Gender: element.Gender,
            College: element.CgName,
            Course: element.CoName,
          }));
  
          // Convert array data to CSV format
          const csvContent = this.convertArrayToCSV(extractedData);
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'UnpaidFeesCountReport.csv'; // You can change the file name if needed
          document.body.appendChild(link);
  
          // Trigger the download
          link.click();
        } else {
        }
      });
    }
    convertArrayToCSV(array) {
      const header = Object.keys(array[0]).join(',');
      const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
      return [header, ...rows].join('\n');
    }

    back(){
      this.alladdmittedCountForm.reset();
      this.table = false
    }
}
